import React from 'react';
export function OrderBump() {
  return <section className="bg-[#091A0F] py-20 px-4" data-id="element-162">
      <div className="max-w-5xl mx-auto" data-id="element-163">
        <h2 className="text-2xl md:text-3xl font-bold text-[#CCFF00] text-center mb-4 drop-shadow-[0_0_8px_rgba(204,255,0,0.3)]" data-id="element-164">
          ¿Qué agrega el Megapack Élite?
        </h2>
        <p className="text-white text-center text-lg mb-12" data-id="element-165">
          Por solo $11.000 más, llevás tu entrenamiento al siguiente nivel.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-166">
          <div className="bg-[#051009] border-2 border-[#CCFF00] rounded-2xl p-8 shadow-[0_0_15px_rgba(204,255,0,0.15)]" data-id="element-167">
            <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3" data-id="element-168">
              <span className="text-3xl" data-id="element-169">🏋️</span> Élite 1 — Pretemporada
              Blindada
            </h3>
            <p className="text-gray-300 leading-relaxed text-lg" data-id="element-170">
              Cómo poner a punto un equipo amateur en 4 semanas sin romper
              jugadores y sin gimnasio. El cronograma completo, los 3 tests de
              campo y el protocolo anti-lesiones que ningún entrenador amateur
              tiene sistematizado. No improvises más la pretemporada cuando
              tenés el año entero por delante.
            </p>
          </div>

          <div className="bg-[#051009] border-2 border-[#CCFF00] rounded-2xl p-8 shadow-[0_0_15px_rgba(204,255,0,0.15)]" data-id="element-171">
            <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3" data-id="element-172">
              <span className="text-3xl" data-id="element-173">🧠</span> Élite 2 — Estrategia PRO:
              Manual de Jugadas Secretas
            </h3>
            <p className="text-gray-300 leading-relaxed text-lg" data-id="element-174">
              Las 20 jugadas de pizarrón que los seleccionados nacionales usan
              para destrabar partidos cerrados. Lectura del rival en 10 minutos,
              protocolo de entretiempo y el Plan Anti-Gigantes para ganar cuando
              el rival tiene más físico que vos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}